import { render } from "./ProjectReport.vue?vue&type=template&id=dcd0b5dc"
import script from "./ProjectReport.vue?vue&type=script&lang=js"
export * from "./ProjectReport.vue?vue&type=script&lang=js"

import "./ProjectReport.vue?vue&type=style&index=0&id=dcd0b5dc&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__